import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../../../../api';
import { WAREHOUSE_ROUTES } from '../../../../constants/routes';

export const useWarehouseAuth = () => {
  const navigate = useNavigate();
  const [adminLogout] = useLogoutMutation();
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const handleLogoutClick = () => {
    setIsLogoutModalOpen(true);
  };

  const handleLogoutConfirm = async () => {
    try {
      const response = await adminLogout();

      if (response.data?.success) {
        // Clear warehouse user data
        localStorage.clear();

        // Navigate to warehouse sign in
        navigate(WAREHOUSE_ROUTES.warehouseSignIn);
      } else {
        console.error('Logout failed: API returned unsuccessful response');
      }
    } catch (error) {
      console.error('Logout failed:', error);

      // Clear local storage anyway and redirect
      localStorage.clear();
      navigate(WAREHOUSE_ROUTES.warehouseSignIn);
    } finally {
      setIsLogoutModalOpen(false);
    }
  };

  const handleLogoutCancel = () => {
    setIsLogoutModalOpen(false);
  };

  return {
    isLogoutModalOpen,
    handleLogoutClick,
    handleLogoutConfirm,
    handleLogoutCancel,
  };
};
